import React, { useState } from 'react';
import { Chip, Menu, MenuItem } from '@material-ui/core';

const FilterChipMenu = ({ label, data, value, onChange }) => {
  const [anchor, setAnchor] = useState(null);

  return (
    <>
      <Chip
        clickable
        aria-haspopup="true"
        size="small"
        label={`${label}: ${data.find((e) => e.id === value)?.label}`}
        color="primary"
        variant="outlined"
        style={{
          marginRight: 6,
          marginBottom: 8,
          padding: 8,
        }}
        onClick={(event) => setAnchor(event.currentTarget)}
      />
      <Menu
        id="basic-menu"
        anchorEl={anchor}
        open={!!anchor}
        onClose={() => setAnchor(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {data.map((e, index) => (
          <MenuItem
            key={'filterChip_' + index}
            onClick={() => {
              setAnchor(null);
              onChange(e.id);
            }}
          >
            {e?.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default FilterChipMenu;
